import { render, staticRenderFns } from "./UpdateLoginConfigDialog.vue?vue&type=template&id=496dd148&scoped=true"
import script from "./UpdateLoginConfigDialog.vue?vue&type=script&lang=js"
export * from "./UpdateLoginConfigDialog.vue?vue&type=script&lang=js"
import style0 from "./UpdateLoginConfigDialog.vue?vue&type=style&index=0&id=496dd148&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496dd148",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('496dd148')) {
      api.createRecord('496dd148', component.options)
    } else {
      api.reload('496dd148', component.options)
    }
    module.hot.accept("./UpdateLoginConfigDialog.vue?vue&type=template&id=496dd148&scoped=true", function () {
      api.rerender('496dd148', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/data/UpdateLoginConfigDialog.vue"
export default component.exports